import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseApiService } from 'src/app/core/services/base-api.service';
import { Invoice } from 'src/app/shared/models/invoice';
import { InvoiceDetails } from 'src/app/shared/models/invoice-details';

@Injectable({
  providedIn: 'root'
})

export class BillingService {
  constructor(private http: HttpClient, private baseApiService: BaseApiService) { }

  getInvoices(): Observable<Invoice[]> {
    const apiUrl = '/customer_object/get_invoices';
    const invoices = this.http.get<Invoice[]>(this.baseApiService.API_URL + apiUrl, {});

    return invoices;
  }

  getInvoiceRows(id: string): Observable<InvoiceDetails[]> {
    const apiUrl = '/customer_object/get_invoice_rows?id=' + id;
    const invoiceRows = this.http.get<InvoiceDetails[]>(this.baseApiService.API_URL + apiUrl, {});

    return invoiceRows;
  }

  createPaymentIntent(id: string) {
    const apiUrl = '/customer_object/create_pay_intent?invoice_id=' + id;
    const paymentIntentSecret = this.http.get(this.baseApiService.API_URL + apiUrl, {});

    return paymentIntentSecret;
  }

  sendPaymentLoad(form, invoiceID) {
    const apiUrl = '/customer_object/process_payment_intent';
    const paymentIntentLoad = this.http.post(this.baseApiService.API_URL + apiUrl, { paymentIntent: form, id: invoiceID });

    return paymentIntentLoad;
  }

  downloadInvoice(id: string) {
    const apiUrl = '/customer_object/download_invoice?invoice_id=' + id;
    const file = this.http.post(this.baseApiService.API_URL + apiUrl, {});

    return file;
  }

}
